import { consumeReturnTo } from "../lib/returnTo";
import { useEffect, useRef } from "react";
import { api } from "../lib/api";

// Gère le retour de Google Auth (Emergent). Le session_id arrive dans le fragment (#session_id=...).
// L'échange session_id -> token se fait via le BACKEND, puis on stocke le token et on redirige.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    // Le portail membre redirige vers /membres ; l'admin vers /app.
    const isMember = window.location.pathname.startsWith("/membres");

    if (!sessionId) {
      window.location.replace(isMember ? "/membres" : "/auth");
      return;
    }

    (async () => {
      try {
        if (isMember) {
          const { data } = await api.post("/member/auth/google/session", { session_id: sessionId });
          localStorage.setItem("member_token", data.token);
          localStorage.setItem("member_profile", JSON.stringify(data.member));
          window.location.replace(consumeReturnTo("/membres"));
        } else {
          const { data } = await api.post("/auth/google/session", { session_id: sessionId });
          localStorage.setItem("map_token", data.access_token);
          localStorage.setItem("map_user", JSON.stringify(data.user));
          window.location.replace(consumeReturnTo("/app"));
        }
      } catch (e) {
        window.location.replace(isMember ? "/membres?err=google" : "/auth?err=google");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-300" data-testid="google-auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-zinc-700 border-t-amber-400 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm">Connexion avec Google…</p>
      </div>
    </div>
  );
}
